import { render, staticRenderFns } from "./ProductPopup.vue?vue&type=template&id=852ccd4e&scoped=true&"
import script from "./ProductPopup.vue?vue&type=script&lang=js&"
export * from "./ProductPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductPopup.vue?vue&type=style&index=0&id=852ccd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ccd4e",
  null
  
)

export default component.exports